module.exports = __webpack_public_path__ + "media/pres_NEW.68410fa7.mp4";